import { useState, useEffect } from 'react';
import request from 'utils/request_ajax';

/**
 *  @typedef {Object} UseFetchReturn
 *  @property {any} data data returned from the endpoint
 *  @property {boolean} loading loading state of the request, changes to true when params changes
 *  @property {boolean} initialLoading first loading state of the request, stays false when params changes
 *  @property {any} error any error returned from the json endpoint
 *  @property {function} runRequest a function to reload re-run the request with the same params
 */

/**
 * useFetch - Hook used to GET fetch data asynchronous
 *
 * @param {string} url GET url of the endpoint we are fetching from
 * @param {function=} updateFn callback function that replaces internal useState hook. Used to maintain data at a higher level
 *
 * @return {UseFetchReturn} The return value of useFetch, an object describing the state of the hook
 */
const useFetch = (url, updateFn) => {
  const [fetchData, setFetchData] = useState(undefined);
  const [loading, setLoading] = useState(true);
  const [initialLoading, setInitialLoading] = useState(true);
  const [error, setError] = useState();

  const runRequest = () => {
    setLoading(true);
    request
      .get(url)
      .then(data => {
        if (updateFn) {
          updateFn(data);
        } else {
          setFetchData(data);
        }
        setError(undefined);
        setLoading(false);
        setInitialLoading(false);
      })
      .catch(e => {
        setError(e);
        setLoading(false);
        setInitialLoading(false);
      });
  };

  useEffect(runRequest, [url, updateFn]);
  return { data: fetchData, loading, initialLoading, error, runRequest };
};

export default useFetch;
